import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[IsValidInvoiceAmountDirective]'
})
export class IsValidInvoiceAmountDirective {
  
  constructor(private _el: ElementRef,
    private control: NgControl) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = String(this._el.nativeElement.value || '').replace(/[^0-9|.]*/g, '');
    const splitArray = initalValue.split('.');

    if (splitArray.length === 1) {
      this.control.control.setValue(splitArray[0].slice(0, 10));
    } else if (splitArray.length === 2 || splitArray.length === 3) {
      this.control.control.setValue(splitArray[0].slice(0, 10) + '.' + splitArray[1].slice(0, 2));
    }
  }

}